import lazyLoad from '@loadable/component'

import createPlugin from './createPlugin'

import VideoRenderer from '@peracto/peracto-blocks-tailwind/dist/content/Video/Renderer/VideoRenderer'

const VideoForm = lazyLoad(() => import('./Form/VideoForm'))

const videoPlugin = settings =>
    createPlugin({
        Renderer: VideoRenderer,
        Controls: VideoForm,
        ...settings,
    })

const video = videoPlugin()
export default video

export { videoPlugin, VideoRenderer }
